import { memo, ReactElement } from 'react';
import { AutocompleteInput, AutocompleteInputProps, ReferenceInput, ReferenceInputProps, SelectInput, SelectInputProps, useResourceContext } from 'react-admin';
import ApplicationForm from '../GeneratedModels/ApplicationForm';
import ReferenceQuickCreateInput from '../react-admin/ReferenceQuickCreateInput';

/**
 * Generated by Db2Ts @ 2023-06-12 15:11:1148
 */

interface ApplicationFormSelectInputProps extends Omit<SelectInputProps, "optionText"> {
  optionText: 'id' | 'created' | 'createdBy' | 'updated' | 'updatedBy' | ((data: ApplicationForm) => string),
}

interface ApplicationFormAutocompleteInputProps extends Omit<AutocompleteInputProps, "optionText"> {
  optionText: keyof ApplicationForm | ((data: ApplicationForm) => string),
  filterProps: Array<keyof ApplicationForm>,
}

interface ApplicationFormReferenceInputProps extends Omit<ReferenceInputProps, 'source' | 'reference' | 'children'> {
  source?: string,
  reference?: string,
  selectInputProps?: ApplicationFormSelectInputProps,
  autocompleteInputProps?: ApplicationFormAutocompleteInputProps,
  filter?: Partial<ApplicationForm>,
  useAutocomplete?: boolean,

  quickCreate?: {
    fields?: ReactElement,
    formElements?: ReactElement,
  }
}

function ApplicationFormReferenceInput({ label, source, reference, selectInputProps, useAutocomplete, autocompleteInputProps, quickCreate, validate, name, ...rest }: ApplicationFormReferenceInputProps) {
  const resource = useResourceContext();
  label = label ?? `resources.${resource}.fields.${source}`
  return (
    quickCreate
      ? <ReferenceQuickCreateInput selectInputProps={selectInputProps as any} {...rest} {...quickCreate} source={source ?? "application_form_id"} reference={reference ?? "application_form"} />
      : <ReferenceInput {...rest} source={source ?? "application_form_id"} reference={reference ?? "application_form"} label={label}>
        {useAutocomplete && autocompleteInputProps
          ? <AutocompleteInput filterToQuery={q => ({ __mode: 'filterToQuery', ...(Object.fromEntries(autocompleteInputProps.filterProps.map(x => [x, q]))) })} {...autocompleteInputProps}/>
          : <SelectInput disabled={rest.disabled} {...selectInputProps} fullWidth validate={validate} name={name} label={label} />
        }
      </ReferenceInput>
  )
}

ApplicationFormReferenceInput.defaultProps = {
  addLabel: true,
  fullWidth: true,
  // label: "ApplicationForm",
  source: "application_form_id",
  reference: "application_form",
  selectInputProps: {
    optionText: 'id',
  },
  autocompleteInputProps: {
    optionText: 'id',
    filterProps: ['id'],
  }
};

export default memo(ApplicationFormReferenceInput);
